import type { UploadWidgetConfig } from '@bytescale/upload-widget';

import { apiKey, sharedLocale, sharedStyles, uploadBucket } from '../../../../utils';

const sharedPathAttraction = {
  folderPath: `${uploadBucket}/devices`,
};

const sharedEditorBase = {
  preview: true,
  crop: true,
  cropShape: 'rect' as const,
};

export const optionDeviceCoverUpload: UploadWidgetConfig = {
  apiKey,
  path: sharedPathAttraction,
  editor: {
    images: {
      ...sharedEditorBase,
      allowResizeOnMove: false,
      cropRatio: 12 / 16,
    },
  },
  styles: sharedStyles,
  layout: 'inline',
  locale: {
    ...sharedLocale,
    cropBtn: 'Crop',
    finishBtnIcon: false,
  },
  maxFileCount: 1,
  maxFileSizeBytes: 4 * 1024 * 1024,
  multi: false,
  showRemoveButton: true,
  showFinishButton: true,
};
